(() => {
  'use strict';
  const key = 'wam_cart_designs_v1';
  const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  let ids = [], lastAttempt = 0, subscribed = false;
  function remember(values) {
    ids = [...new Set(values.filter(value => typeof value === 'string' && uuid.test(value)))];
    try { localStorage.setItem(key, JSON.stringify({ ids, at: Date.now() })); } catch (_) {}
  }
  try {
    const saved = JSON.parse(localStorage.getItem(key) || 'null');
    if (saved?.at > Date.now() - 86400000 && Array.isArray(saved.ids)) ids = saved.ids.filter(id => uuid.test(id));
  } catch (_) {}
  async function refresh() {
    try {
      const response = await fetch('/cart.js', { cache: 'no-store', signal: AbortSignal.timeout(5000) });
      if (!response.ok) return;
      const cart = await response.json();
      if (Array.isArray(cart.items)) remember(cart.items.map(item => item.properties?._design_id));
    } catch (_) {}
  }
  function attempt() {
    if (!ids.length || Date.now() - lastAttempt < 1500) return;
    lastAttempt = Date.now();
    const properties = { tasarim_idleri: ids.slice(0, 20), kaynak: 'magaza_tiklama',
      surum: 'wam-custom-20260913-photo-first', test_mi: new URLSearchParams(location.search).has('sinama') ? 'evet' : 'hayir' };
    try { window.posthog?.capture('wam_checkout_deneme', properties, { send_instantly: true }); } catch (_) {}
    try { window.dataLayer?.push({ event: 'wam_checkout_deneme', ...properties }); } catch (_) {}
  }
  document.addEventListener('wam:cart-confirmed', event => { if (Array.isArray(event.detail?.ids)) remember(event.detail.ids); });
  document.addEventListener('click', event => {
    const target = event.composedPath().find(node => typeof node.matches === 'function' && node.matches('a[href],button[name="checkout"],input[name="checkout"]'));
    if (!target) return;
    if (target.name === 'checkout') return attempt();
    try { if (/^\/checkouts?(?:\/|$)/.test(new URL(target.href, location.href).pathname)) attempt(); } catch (_) {}
  }, true);
  document.addEventListener('submit', event => { if (event.submitter?.name === 'checkout') attempt(); }, true);
  function connect() {
    if (!subscribed && typeof window.upcartSubscribeCartUpdated === 'function') {
      subscribed = true; window.upcartSubscribeCartUpdated(refresh);
      window.upcartSubscribeCartLoaded?.(refresh); window.upcartSubscribeCartOpened?.(refresh);
    }
  }
  connect(); refresh(); window.addEventListener('load', connect, { once: true });
})();
